<template lang="html">
	<entity-page id="page__storages-settings" v-loader-overlay="progress">
		<template slot="header-right">
			<z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
		</template>
		
        <FlexTabs v-bind:tabs="tabs" v-model="activeTab" min />
        <ZModulePropertiesLogs v-if="activeTab === 'tab-logs'" v-bind:module="this.module" v-bind:properties="properties"></ZModulePropertiesLogs>

        <div v-if="form && activeTab === 'tab-settings'" class="page__storages-settings__settings row">
            <z-module-properties-input v-model="form" :properties="props.labels" ref="inputs-labels" />
            <z-module-properties-input v-model="form" :properties="props.settings" ref="inputs-settings" />
            <ZDates
                label="Выходные и праздничные дни"
                v-model="formDate.exist"
                v-on:change-year="onChangeDate"
                v-on:check="onDateCheck"
                v-on:uncheck="onDateUnCheck"
            ></ZDates>
        </div>
	</entity-page>
</template>
<script>
    import FlexTabs from '@/components/FlexTabs';
	import ZInput   from '@/components/ZInput';
	import ZSelect  from '@/components/ZSelect';
    import ZDates   from '@/components/ZDates';
    import ZDate    from '@/components/ZDate';
	import EntityPage  from '@/components/EntityPage.vue';
	import ToggleCard  from '@/components/ToggleCard';
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZInputAutocomplete     from '@/components/ZInputAutocomplete';
    import ZModulePropertiesLogs  from '@/components/ZModulePropertiesLogs';
    import ZModulePropertiesInput from '@/components/ZModulePropertiesInput'
	export default {
		components: {
            ZDates, ZDate, ZInput, ZSelect, ZInputAutocomplete, EntityPage,
            ToggleCard, ZIconButton, ZModulePropertiesLogs,
            FlexTabs, ZModulePropertiesInput
        },
		data() {
			return {
                module: 'cost',
                props: {
                    labels: [
                        'storage_label'
                    ], 
                    settings: [
                        'storage_delivery_type'
                    ]
                },
                entities: [ 'storage_date' ],
                formDate: {
                    year:  this.moment().format('Y'),
                    create: [],
                    delete: [],
                    exist:  [],
                },
                form: {},
                activeTab: 'tab-settings',
                tabs: [
                    {name: "tab-settings", label: "Настройки"},
                    {name: "tab-logs",     label: "История"},
                ],
                refs: [
                    'inputs-labels'
                ]
            }
		},
		computed: {
            progressKey() {
                return 'load-storages-settings-card';
            },
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj[this.progressKey];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
            properties() {
                const result = [];
                Object.values(this.props).map(item => result.push(...item));

                return result.concat(this.entities);
            },
		},
		methods: {
			/**
			 * Возвращение пользователя на предидущую страницу
			 */
			back() {
				this.$router.push({name: 'StoragePrices', query: this.$route.query});
			},
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$store.commit('openRightPanel');
                this.formDate.create = [];
                this.formDate.delete = [];
                this.formDate.exist  = [];
                this.getValues();
                this.getDates();
			},
			/**
			 * Получение списка значений параметров
			 */            
            getValues() {
                this.$store.commit('showProgressBar', this.progressKey);
                this.$store.dispatch('module/getModuleProperties', { module: this.module }).then(r => {
                    if (!r) return;
                    Object.entries(r)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => {
                            if (!value.value && value.default_value) value.value = value.default_value;
                            this.$set(this.form, key, Object.assign(value))
                        });
                }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
            },
			/**
			 * Получение списка дат за указанный год
			 */            
            getDates() {
				return this.$store.dispatch('cost/getStorageDates', {
					page: 1, order_by: 'date', order_type: 'asc', count: 'all',
					filter: {
                        'model': [
                            ['date', '>=', `${this.formDate.year}-01-01`], 'and',
                            ['date', '<=', `${this.formDate.year}-12-31`], 'and',
                            ['storage', '=', 0]
                        ]
                    }
				}).then(dates => this.setExistDates(dates));
            },
			/**
			 * Сохраняет полученные с сервера даты в локальную переменную
			 */            
            setExistDates(dates) {
                if (!dates || !dates.length) this.formDate.exist = Object.assign([], []);
                this.formDate.exist = Object.assign([], dates.filter(date => parseInt(date.storage) === 0).map(date => date.date));
            },
			/**
			 * Вызывается когда пользователь в календаре меняет год
             * необходимо чтобы подкачивать даты только по текущему году
			 */            
            onChangeDate(date) {
                if (!date) return
                this.formDate.year = date.format('Y')
                this.getDates()
            },
            /**
			 * Вызывается когда пользователь отмечает дату
			 */
            onDateCheck(date) {
                if (!date) return
                this.formDate.create.push(date.format('Y-MM-DD'))
            },
			/**
			 * Вызывается когда пользоавтель снимает отметку с даты
			 */
            onDateUnCheck(date) {
                if (!date) return
                this.formDate.delete.push(date.format('Y-MM-DD'))
            },
			/**
			 * Сохранение данных
			 */
			async save() {
                if (this.progress) return;

                this.$store.commit('showProgressBar', this.progressKey);
                await Promise.all([
                    this.saveDates(),
                    this.deleteDates(),
                    this.saveProperties()
                ])
                this.$store.commit('hideProgressBar', this.progressKey)
                this.init()
			},
			/**
			 * Сохранение настроек модуля
			 */            
            async saveProperties() {
                await Promise.all(this.refs.map(key => this.$refs[key].validate())).then(async valid => {
                    if (!valid.every(i => !!i)) return;
                    const data = {module: this.module, values: []};

                    Object.entries(this.form)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => data.values.push({
                            module_name:  this.module,
                            prop_code:    key,
                            value:        value.value
                        }))

                    await this.$store.dispatch('module/setModulePropertiesValue', data).then(() => this.init());
                });
            },
			/**
			 * Сохранение новых добавленных дат
			 */            
            saveDates() {
                return this.$store.dispatch('cost/postStorageDate', { dates: this.formDate.create });
            },
			/**
			 * Удаление дат, с которых пользователь снял выделение
			 */            
            deleteDates() {
                return this.$store.dispatch('cost/deleteStorageDate', { dates: this.formDate.delete });
            }            
		},
        created() {
			this.init();
		}
	}
</script>
<style lang="sass">
    #page__storages-settings
        .page__storages-settings__settings.row
            margin: 0
            .col-6
                margin: 0 5px 10px 5px
                width: calc(50% - 10px)
            
</style>


// WEBPACK FOOTER //
// StoragesSettings.vue?cd17ecf2